<template>
  <div class="flex flex-col h-full min-h-0 w-full min-w-0">
    <PrPageHeader @show-sidebar="onShowSidebar">
      <span class="text-xl font-bold">{{ greeting }}</span>
    </PrPageHeader>

    <div class="flex-1 min-h-0 overflow-y-auto p-4 sm:p-6">
      <div class="space-y-6 max-w-7xl mx-auto w-full">
        <section v-for="section in sections" :key="section.key">
          <div class="section-header">
            <span class="material-symbols-rounded text-gray-400">{{ section.icon }}</span>
            <h3 class="text-sm font-medium text-gray-600 uppercase tracking-wide">
              {{ section.label }}
            </h3>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div
              v-for="card in section.items"
              :key="card.key"
              class="nav-card"
              @click="router.push({ name: card.route })"
            >
              <div class="nav-card-icon" :class="section.colorClass">
                <span class="material-symbols-rounded text-2xl">{{ card.icon }}</span>
              </div>
              <div class="flex flex-col">
                <span class="font-semibold text-gray-900">{{ card.label }}</span>
                <span class="text-xs text-gray-500 font-medium">{{ card.description }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import PrPageHeader from '@/components/PrPageHeader.vue';
import { useHomeCards } from '@/composables/useHomeCards';

const emits = defineEmits(['showSidebar']);
const router = useRouter();
const { greeting, sections } = useHomeCards();

const onShowSidebar = () => {
  emits('showSidebar');
};
</script>

<style scoped>
@reference 'tailwindcss';

.section-header {
  @apply flex items-center gap-2 pb-2 border-b border-gray-200 mb-3;
}

.nav-card {
  @apply flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-100 shadow-sm
         cursor-pointer transition-all duration-150 hover:border-gray-200;
}

.nav-card-icon {
  @apply flex items-center justify-center w-12 h-12 rounded-lg flex-shrink-0;
}
</style>
